module.exports = __webpack_public_path__ + "img/MJ.7ca577e5.png";